import React from "react";
import Header from "./Header";
import SideBar from "./SideBar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
// import useScript from "../hooks/useScript";

export default function AdminLayout({ children }) {
  return (
    <React.Fragment>
      <Header />
      <SideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">{children}</div>
        </div>
        <Footer />
      </div>
    </React.Fragment>
  );
}
